import { SCHOOL_SETTINGS } from "./setup";
import VueScrollTo from "vue-scrollto";

export function setupScroll(app) {
  app.use(VueScrollTo, {
    container: "body",
    duration: SCHOOL_SETTINGS.test_details ? 1 : 500,
    easing: "ease",
    offset: 0,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true,
  });
}
